import * as basicLightbox from 'basiclightbox';

document.addEventListener('click', function (e) {
  const lightboxItem = e.target.closest('.js-lightbox-item');

  if (lightboxItem) {
    if (e.target.closest('.btn-download')) {
      return;
    }

    e.preventDefault();
    const sourceUrl = lightboxItem.dataset.src;
    const isVideo = lightboxItem.dataset.type === 'video';

    if (sourceUrl) {
      if (isVideo) {
        basicLightbox.create(`
          <video controls autoplay>
            <source src="${sourceUrl}" type="video/mp4">
          </video>
        `).show();
      } else {
        basicLightbox.create(`<img src="${sourceUrl}">`).show();
      }
    }
  }
});
